import { Box, SxProps } from "@mui/material"
import { Theme } from "@mui/system"
import React from "react"

export interface IThreeDotLoaderProps {
  sx?: SxProps<Theme>
}

export const ThreeDotLoader = React.memo(
  ({ sx }: IThreeDotLoaderProps): JSX.Element => (
    <Box
      sx={{
        width: "1rem",
        height: "1rem",
        borderRadius: "50%",
        display: "block",
        margin: "1rem auto",
        position: "relative",
        background: theme => theme.palette.specialText,
        boxShadow: theme => `-1.5rem 0 ${theme.palette.specialText}, 1.5rem 0 ${theme.palette.specialText}`,
        boxSizing: "border-box",
        animation: "shadowPulse 2s linear infinite",
        ...sx
      }}
    />
  )
)
